import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../lib/api.js';
import '../styles/encounter.css';

/**
 * Player-flow: /room/:id/join → вибір персонажа → /room/:id/play з session у LS.
 */
export function RoomJoin(): JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [info, setInfo] = useState<{ encounter: { id: string; name: string }; players: Array<{ id: string; name: string; icon?: string }> } | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.encounterJoinInfo(id).then(setInfo).catch((e: Error) => setErr(e.message));
  }, [id]);

  const pick = async (combatantId: string): Promise<void> => {
    try {
      const r = await api.encounterJoin(id, combatantId);
      localStorage.setItem(`sd:player-session:${id}`, r.session.id);
      navigate(`/room/${id}/play`);
    } catch (e) { setErr((e as Error).message); }
  };

  if (err) return <div className="encounter-body"><h1 style={{ color: 'var(--blood-bright)' }}>⚠ {err}</h1></div>;
  if (!info) return <div className="encounter-body" style={{ color: 'var(--text-dim)' }}>завантажую…</div>;

  return (
    <div className="encounter-shell">
      <div className="encounter-body">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h1 style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--gold-bright)', fontSize: 28, margin: 0 }}>{info.encounter.name}</h1>
          <p style={{ color: 'var(--text-muted)', marginTop: 4 }}>Обери свого героя</p>
        </div>

        <div className="player-pick-grid">
          {info.players.map((p) => (
            <button key={p.id} className="player-pick-card" onClick={() => void pick(p.id)}>
              <h3>{p.name}</h3>
              <span style={{ color: 'var(--text-dim)', fontSize: 11, fontFamily: 'Spline Sans Mono, monospace' }}>
                {p.icon ?? ''}
              </span>
            </button>
          ))}
          {info.players.length === 0 && (
            <p style={{ color: 'var(--text-dim)', gridColumn: '1 / -1', textAlign: 'center' }}>
              У цій зустрічі ще не додано героїв. Попроси GM-а.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
